import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Translation } from 'react-i18next';
import { object, string, arrayOf, any, func, bool } from 'prop-types';
import FormSelect from '../../components/FormSelect';
import FormText from '../../components/FormText';
import FormPhoneNumber from '../../components/FormPhoneNumber';

const styles = theme => ({
  component: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  barLayout: {
    padding: theme.spacing(1),
  },
  phoneNumberContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  marginStyle: {
    marginLeft: theme.spacing(2),
  },
  subPage: {
    marginTop: theme.spacing(2),
  },
});

const ContactDetailsComponent = ({
  classes,
  phoneNumber,
  phoneNumberError,
  isPhoneNumberRequired,
  email,
  emailError,
  isEmailRequired,
  phoneNumberChanged,
  emailChanged,
  street,
  streetError,
  isStreetRequired,
  city,
  cityError,
  isCityRequired,
  residenceState,
  residenceStateError,
  isResidenceStateRequired,
  postalCode,
  postalCodeError,
  isPostalCodeRequired,
  residenceCountry,
  residenceCountryError,
  isResidenceCountryRequired,
  residenceCountries,
  streetChanged,
  cityChanged,
  residenceStateChanged,
  postalCodeChanged,
  residenceCountryChanged,
  fullName,
  fullNameError,
  isFullNameRequired,
  ecPhoneNumber,
  ecPhoneNumberError,
  isEcPhoneNumberRequired,
  ecEmail,
  ecEmailError,
  isEcEmailRequired,
  fullNameChanged,
  ecPhoneNumberChanged,
  ecEmailChanged,
  targetCountryCode,
  readOnly = false,
}) => (
  <Translation>
    {t => {
      return (
        <div>
          <Typography
            className={classes.barLayout}
            style={{ color: '#ffffff', background: '#4CAF50' }}
            variant="subtitle1"
            align="left"
            gutterBottom
          >
            {t('contactDetails')}
          </Typography>
          <Grid
            container
            spacing={3}
            alignItems="flex-end"
            direction="row"
            key="form-grid-container1"
          >
            <Grid className={classes.phoneNumberContainer} item xs={6}>
              <Grid item xs={6}>
                <FormPhoneNumber
                  id="phonenumber"
                  label={t('mobileCellPhone')}
                  value={phoneNumber}
                  onChange={phoneNumberChanged}
                  readOnly={readOnly}
                  required={isPhoneNumberRequired}
                  error={phoneNumberError}
                  defaultCountryCode={targetCountryCode}
                />
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="email"
                label={t('email2')}
                value={email}
                onChange={emailChanged}
                readOnly={readOnly}
                tooltip=""
                required={isEmailRequired}
                error={emailError}
              />
            </Grid>
          </Grid>
          <div className={classes.subPage} />
          <Typography
            className={classes.barLayout}
            style={{ color: '#ffffff', background: '#4CAF50' }}
            variant="subtitle1"
            align="left"
            gutterBottom
          >
            {t('homeAddress')}
          </Typography>
          <Grid container spacing={3} key="form-grid-container2">
            <Grid item xs={6}>
              <FormSelect
                className={classes.component}
                id="residence-country"
                label={t('countryResidence')}
                value={residenceCountry}
                options={residenceCountries}
                onChange={residenceCountryChanged}
                readOnly={readOnly}
                required={isResidenceCountryRequired}
                error={residenceCountryError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="residence-state"
                label={t('state')}
                value={residenceState}
                onChange={residenceStateChanged}
                readOnly={readOnly}
                tooltip=""
                required={isResidenceStateRequired}
                error={residenceStateError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="city"
                label={t('city')}
                value={city}
                onChange={cityChanged}
                readOnly={readOnly}
                tooltip=""
                required={isCityRequired}
                error={cityError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="street"
                label={t('street')}
                value={street}
                onChange={streetChanged}
                readOnly={readOnly}
                tooltip=""
                required={isStreetRequired}
                error={streetError}
              />
            </Grid>

            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="postal-code"
                label={t('postalCode')}
                value={postalCode}
                onChange={postalCodeChanged}
                readOnly={readOnly}
                tooltip=""
                required={isPostalCodeRequired}
                error={postalCodeError}
              />
            </Grid>
          </Grid>
          <div className={classes.subPage} />
          <Typography
            className={classes.barLayout}
            style={{ color: '#ffffff', background: '#4CAF50' }}
            variant="subtitle1"
            align="left"
            gutterBottom
          >
            {t('emergencyContact')}
          </Typography>
          <Grid
            container
            spacing={3}
            alignItems="flex-end"
            key="form-grid-container3"
          >
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="full-name"
                label={t('fullName')}
                value={fullName}
                onChange={fullNameChanged}
                readOnly={readOnly}
                tooltip=""
                required={isFullNameRequired}
                error={fullNameError}
              />
            </Grid>
            <Grid className={classes.phoneNumberContainer} item xs={6}>
              <Grid item xs={6}>
                <FormPhoneNumber
                  id="ecPhonenumber"
                  label={t('phoneNumber')}
                  value={ecPhoneNumber}
                  onChange={ecPhoneNumberChanged}
                  readOnly={readOnly}
                  required={isEcPhoneNumberRequired}
                  error={ecPhoneNumberError}
                  defaultCountryCode={targetCountryCode}
                />
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="email"
                label={t('email')}
                value={ecEmail}
                onChange={ecEmailChanged}
                readOnly={readOnly}
                tooltip=""
                required={isEcEmailRequired}
                error={ecEmailError}
              />
            </Grid>
          </Grid>
        </div>
      );
    }}
  </Translation>
);

ContactDetailsComponent.propTypes = {
  classes: object.isRequired,
  phoneNumber: string.isRequired,
  phoneNumberError: string,
  isPhoneNumberRequired: bool.isRequired,
  email: string.isRequired,
  emailError: string,
  isEmailRequired: bool.isRequired,
  phoneNumberChanged: func.isRequired,
  emailChanged: func.isRequired,
  street: string.isRequired,
  streetError: string,
  isStreetRequired: bool.isRequired,
  city: string.isRequired,
  cityError: string,
  isCityRequired: bool.isRequired,
  residenceState: string.isRequired,
  residenceStateError: string,
  isResidenceStateRequired: bool.isRequired,
  postalCode: string.isRequired,
  postalCodeError: string,
  isPostalCodeRequired: bool.isRequired,
  residenceCountry: string,
  residenceCountryError: string,
  isResidenceCountryRequired: bool.isRequired,
  residenceCountries: arrayOf(any).isRequired,
  streetChanged: func.isRequired,
  cityChanged: func.isRequired,
  residenceStateChanged: func.isRequired,
  postalCodeChanged: func.isRequired,
  residenceCountryChanged: func.isRequired,
  fullName: string.isRequired,
  fullNameError: string,
  isFullNameRequired: bool.isRequired,
  ecPhoneNumber: string.isRequired,
  ecPhoneNumberError: string,
  isEcPhoneNumberRequired: bool.isRequired,
  ecEmail: string.isRequired,
  ecEmailError: string,
  isEcEmailRequired: bool.isRequired,
  fullNameChanged: func.isRequired,
  ecPhoneNumberChanged: func.isRequired,
  ecEmailChanged: func.isRequired,
  targetCountryCode: string.isRequired,
};

export default withStyles(styles)(ContactDetailsComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Application/ContactDetails/ContactDetailsComponent.js